<template>
<div class="index-header-wrap">
  <div class="logo">
    <img src="~@/assets/image/logo-black.png" alt="logo" class="logo">
  </div>
  <div class="header-option-icon">
    <i @click="logout" class="iconfont icon-guanbi4"></i>
  </div>
</div>
</template>

<script>

import common from '@/util/common'
import KwHelper from '@/components/custom/KwHelper'

export default {
  name: 'Header',
  data () {
    return {
      tipVisible: false,
      userRole: null
    }
  },
  components: {
    KwHelper
  },
  methods: {
    clearLoginInfo () {
      let searchUserId = location.search.split('userId=')[1] ? { userId: location.search.split('userId=')[1].split('&')[0] } : null
      let userInfo = JSON.parse(sessionStorage.getItem('user_info')) || searchUserId || (top.GLOBAL ? top.GLOBAL.user : null) || {}
      sessionStorage.removeItem('login_validate_id')
      localStorage.removeItem(`kw_token-${userInfo.userId}`)
      localStorage.removeItem('kw_refresh_token')
    },
    logout () {
      window.close()
    }
  },
  mounted () {
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.index-header-wrap{
  width: 100%;
  height: 60px;
  background: #ecebe6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .logo{
    display: inline-block;
    img{
      width: auto;
      height: 60px;
    }
  }
  .header-option-icon{
    height: 60px;
    margin-right: 10px;
    display: flex;
    align-items: center;
    a{
      text-decoration: none;
    }
    i{
      font-size: 26px;
      display: inline-block;
      color: #333;
      margin: 15px;
      cursor: pointer;
    }
    .icon-guanbi4{
      font-size: 24px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home-work/IndexHeader.vue